import axios from "axios";

import { SERVER_URL } from "../../config";
import { appendTimestamp } from "../../common/shared";
import states_list from "../../data/us_states.json";
import country_list from "../../data/country_list.json";
import React from "react";

const DATATYPE_CLIENT = "CLIENT";
const DATATYPE_COCLIENT = "COCLIENT";
const DATATYPE_FAMILY = "FAMILY";
const DATATYPE_OTHER = "OTHER";

const MALE = "Male";
const FEMALE = "Female";
const NON_BINARY = "Non Binary";
const GENDER_OTHER = "Other";
const PREFER_NOT_TO_SAY = "Prefer Not to Say";

export const GENDER_MAP = {
  MALE: MALE,
  FEMALE: FEMALE,
  NON_BINARY: NON_BINARY,
  OTHER: GENDER_OTHER,
  PREFER_NOT_TO_SAY: PREFER_NOT_TO_SAY,
};

export const GENDER_VALUE_MAP = {
  Male: "MALE",
  Female: "FEMALE",
  "Non Binary": "NON_BINARY",
  Other: "OTHER",
  "Prefer Not to Say": "PREFER_NOT_TO_SAY",
};

const MONTH_MAP = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const MONTH_NUM_MAP = {
  Jan: 1,
  Feb: 2,
  Mar: 3,
  Apr: 4,
  May: 5,
  Jun: 6,
  Jul: 7,
  Aug: 8,
  Sep: 9,
  Oct: 10,
  Nov: 11,
  Dec: 12,
};

const MONTH_NAME_MAP = {
  1: "Jan",
  2: "Feb",
  3: "Mar",
  4: "Apr",
  5: "May",
  6: "Jun",
  7: "Jul",
  8: "Aug",
  9: "Sep",
  10: "Oct",
  11: "Nov",
  12: "Dec",
};

const getState = (key) => {
  const selectedState = states_list.filter((state) => {
    return state["alpha-2"] === key;
  });
  if (selectedState != null && selectedState.length > 0)
    return selectedState[0];
  else return { name: "", "alpha-2": "" };
};

const getCountry = (key) => {
  const selectedCountry = country_list.filter((country) => {
    return country["id"] === key;
  });
  if (selectedCountry != null && selectedCountry.length > 0)
    return selectedCountry[0];
  else return country_list[0];
};

const mapBEClientToFE = (personView, id) => {
  let person = {
    id: id,
    personId: personView.personId,
    firstName: personView.firstName,
    lastName: personView.lastName,
    middleName: personView.middleName,
    salutation: personView.salutation,
    status:
      personView.status == null
        ? { id: "Active", value: "Active" }
        : { id: personView.status, value: personView.status },
    gender:
      GENDER_MAP[personView.gender] == null
        ? MALE
        : GENDER_MAP[personView.gender],
    genderOther: personView.otherGender,
    dateOfBirth: personView.dateOfBirth,
    lifeExpectancyAge:
      personView.keyDates == null
        ? null
        : personView.keyDates.lifeExpectancyAge,
    retirementAge:
      personView.keyDates == null ? null : personView.keyDates.retirementAge,
    lifeExpectancyMonth:
      personView.keyDates == null
        ? "Jan"
        : MONTH_NAME_MAP[personView.keyDates.lifeExpectancyMonth],
    retirementMonth:
      personView.keyDates == null
        ? "Jan"
        : MONTH_NAME_MAP[personView.keyDates.retirementMonth],
    notes: personView.notes,
    company: {
      companyId: personView.company ? personView.company.companyId : null,
      name: personView.company ? personView.company.name : "",
      website: personView.company ? personView.company.website : "",
    },
    addressList:
      personView.addressList != null && personView.addressList.length > 0
        ? personView.addressList.map((address, index) => {
            address.country = getCountry(address.country);
            if (address.country.id === "USA") {
              address.state = getState(address.state);
            }
            return address;
          })
        : [
            {
              addressId: null,
              addressLine: "",
              city: "",
              state: { name: "Alabama", "alpha-2": "AL" },
              zipCode: "",
              country: { id: "USA", name: "United States" },
            },
          ],
    emailList:
      personView.emailList != null && personView.emailList.length > 0
        ? [...personView.emailList]
        : [
            {
              emailAddressId: null,
              emailAddressType: "HOME",
              emailAddress: "",
            },
          ],
    phoneList:
      personView.phoneList != null && personView.phoneList.length > 0
        ? [...personView.phoneList]
        : [
            {
              phoneNumberId: null,
              phoneNumberType: "PERSONAL",
              phoneNumber: "",
            },
          ],
  };
  if (personView.isSocialSecurityEligible) {
    person.isEligibleSocialSecuritySpousalBenefit =
      personView.isSocialSecurityEligible;
  }
  return person;
};

const mapFEClientToBE = (client, dataType) => {
  let payload = {
    personId: client.personId,
    firstName: client.firstName,
    middleName: client.middleName,
    lastName: client.lastName,
    salutation: client.salutation,
    dateOfBirth: client.dateOfBirth,
    gender:
      GENDER_VALUE_MAP[client.gender] == null
        ? "M"
        : GENDER_VALUE_MAP[client.gender],
    otherGender: client.genderOther,
    company: {
      companyId: client.company.companyId,
      name: client.company.name,
      website: client.company.website,
    },
    addressList: [...client.addressList],
    emailList: client.emailList.filter(
      (email) => email.emailAddress != null && email.emailAddress !== ""
    ),
    phoneList: client.phoneList
      .map((phone, index) => {
        if (phone.phoneNumber === "___-___-____") {
          phone.phoneNumber = "";
        }
        return phone;
      })
      .filter((phone) => phone.phoneNumber !== ""),
    notes: client.notes,
  };

  switch (dataType) {
    case DATATYPE_CLIENT:
      payload["clientId"] = client.id;
      payload["keyDates"] = {
        retirementAge: client.retirementAge,
        retirementMonth: MONTH_NUM_MAP[client.retirementMonth],
        lifeExpectancyAge: client.lifeExpectancyAge,
        lifeExpectancyMonth: MONTH_NUM_MAP[client.lifeExpectancyMonth],
      };
      payload["relationshipType"] = "CLIENT";
      payload["profileQuestionsView"] = {
        hasHealthInsurance: client.hasHealthInsurance,
        hasDisabilityInsurance: client.hasDisabilityInsurance,
        hasWill: client.hasWill,
        hasTrust: client.hasTrust,
        isBeneficiariesUpToDate: client.isBeneficiariesUpToDate,
      };
      payload["status"] = client.status.id;
      break;
    case DATATYPE_COCLIENT:
      payload["coClientId"] = client.id;
      payload["keyDates"] = {
        retirementAge: client.retirementAge,
        retirementMonth: MONTH_NUM_MAP[client.retirementMonth],
        lifeExpectancyAge: client.lifeExpectancyAge,
        lifeExpectancyMonth: MONTH_NUM_MAP[client.lifeExpectancyMonth],
      };
      payload["relationshipType"] = "COCLIENT";
      payload["isSocialSecurityEligible"] =
        client.isEligibleSocialSecuritySpousalBenefit;
      break;
    case DATATYPE_OTHER:
      payload["contactId"] = client.id;
      payload["relationShip"] = client.relationShip.id;
      payload["relationshipOther"] = client.relationshipOther;
      break;
    default:
      payload["familyMemberId"] = client.id;
      payload["relationshipType"] = client.relationshipType.id;
  }
  return payload;
};

export const getClientAndCoClient = (advisorId, clientId) => {
  console.log("Advisor API - getClientAndCoClient");

  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/client/${clientId}/client-profile`
    );

    axios.get(targetUrl).then((response) => {
      const payload = response.data.payload;

      let clientData = {};
      clientData["client"] = mapBEClientToFE(
        payload.client,
        payload.client.clientId
      );
      clientData["client"].relationshipType = "CLIENT";
      clientData["client"].status = {
        id: payload.client.status,
        value: payload.client.status,
      };
      clientData["client"].hasHealthInsurance =
        payload.client.profileQuestionsView.hasHealthInsurance;
      clientData["client"].hasDisabilityInsurance =
        payload.client.profileQuestionsView.hasDisabilityInsurance;
      clientData["client"].hasWill =
        payload.client.profileQuestionsView.hasWill;
      clientData["client"].hasTrust =
        payload.client.profileQuestionsView.hasTrust;
      clientData["client"].isBeneficiariesUpToDate =
        payload.client.profileQuestionsView.isBeneficiariesUpToDate;

      if (payload.coClient) {
        clientData["coClient"] = mapBEClientToFE(
          payload.coClient,
          payload.coClient.coClientId
        );
        clientData["coClient"].relationshipType = "COCLIENT";
      } else {
        clientData["coClient"] = {
          personId: null,
          firstName: "",
          lastName: "",
          dateOfBirth: "",
          lifeExpectancyAge: null,
          retirementAge: null,
        };
      }

      clientData["family"] = payload.familyMemberList.map((member) => {
        let newMember = mapBEClientToFE(member, member.familyMemberId);
        newMember.relationshipType = member.relationshipType;
        return newMember;
      });

      resolve(clientData);
    });
  });
};

export const saveClient = (advisorId, client) => {
  console.log("Advisor API - saveClient");
  if (client.clientId === null) return postClient(advisorId, client);
  return putClient(advisorId, client.clientId, client);
};

export const postClient = (advisorId, client) => {
  return new Promise((resolve, reject) => {
    let targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/client`
    );

    axios
      .post(targetUrl, mapFEClientToBE(client, DATATYPE_CLIENT))
      .then((response) => {
        let newClient = mapBEClientToFE(
          response.data.payload,
          response.data.payload.clientId
        );
        newClient.hasHealthInsurance =
          response.data.payload.profileQuestionsView.hasHealthInsurance;
        newClient.hasDisabilityInsurance =
          response.data.payload.profileQuestionsView.hasDisabilityInsurance;
        newClient.hasWill = response.data.payload.profileQuestionsView.hasWill;
        newClient.hasTrust =
          response.data.payload.profileQuestionsView.hasTrust;
        newClient.isBeneficiariesUpToDate =
          response.data.payload.profileQuestionsView.isBeneficiariesUpToDate;
        resolve(newClient);
      });
  });
};

export const putClient = (advisorId, clientId, client) => {
  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/client/${clientId}`
    );

    axios
      .put(targetUrl, mapFEClientToBE(client, DATATYPE_CLIENT))
      .then((response) => {
        let newClient = mapBEClientToFE(
          response.data.payload,
          response.data.payload.clientId
        );
        newClient.hasHealthInsurance =
          response.data.payload.profileQuestionsView.hasHealthInsurance;
        newClient.hasDisabilityInsurance =
          response.data.payload.profileQuestionsView.hasDisabilityInsurance;
        newClient.hasWill = response.data.payload.profileQuestionsView.hasWill;
        newClient.hasTrust =
          response.data.payload.profileQuestionsView.hasTrust;
        newClient.isBeneficiariesUpToDate =
          response.data.payload.profileQuestionsView.isBeneficiariesUpToDate;
        resolve(newClient);
      });
  });
};

export const saveCoClient = (advisorId, clientId, coClient) => {
  console.log("Advisor API - saveCoClient");
  if (!coClient.coClientId) return postCoClient(advisorId, clientId, coClient);
  return putCoClient(advisorId, clientId, coClient.coClientId, coClient);
};

export const postCoClient = (advisorId, clientId, coClient) => {
  return new Promise((resolve, reject) => {
    let targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/client/${clientId}/co-client`
    );

    axios
      .post(targetUrl, mapFEClientToBE(coClient, DATATYPE_COCLIENT))
      .then((response) => {
        resolve(
          mapBEClientToFE(
            response.data.payload,
            response.data.payload.coClientId
          )
        );
      });
  });
};

export const putCoClient = (advisorId, clientId, coClientId, coClient) => {
  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/client/${clientId}/co-client/${coClientId}`
    );

    axios
      .put(targetUrl, mapFEClientToBE(coClient, DATATYPE_COCLIENT))
      .then((response) => {
        resolve(
          mapBEClientToFE(
            response.data.payload,
            response.data.payload.coClientId
          )
        );
      });
  });
};

const postFamilyMember = (advisorId, clientId, familyMember) => {
  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/client/${clientId}/family-member`
    );

    axios
      .post(targetUrl, mapFEClientToBE(familyMember, DATATYPE_FAMILY))
      .then((response) => {
        console.log(response.data.payload);
        resolve(
          mapBEClientToFE(
            response.data.payload,
            response.data.payload.familyMemberId
          )
        );
      });
  });
};

const postOtherMember = (advisorId, clientId, otherMember) => {
  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/client/${clientId}/client-contacts`
    );

    axios
      .post(targetUrl, mapFEClientToBE(otherMember, DATATYPE_OTHER))
      .then((response) => {
        console.log(response.data.payload);
        resolve(
          mapBEClientToFE(
            response.data.payload,
            response.data.payload.contactId
          )
        );
      });
  });
};

const putFamilyMember = (advisorId, clientId, familyMemberId, familyMember) => {
  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/client/${clientId}/family-member/${familyMemberId}`
    );

    axios
      .put(targetUrl, mapFEClientToBE(familyMember, DATATYPE_FAMILY))
      .then(() => resolve({}));
  });
};

const putOtherMember = (advisorId, clientId, otherMemberId, otherMember) => {
  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/client/${clientId}/client-contacts/${otherMemberId}`
    );

    axios
      .put(targetUrl, mapFEClientToBE(otherMember, DATATYPE_OTHER))
      .then(() => resolve({}));
  });
};

export const saveFamilyMember = (
  advisorId,
  clientId,
  familyMemberId,
  familyMember
) => {
  console.log("Advisor API - saveFamilyMember");

  if (familyMemberId == null)
    return postFamilyMember(advisorId, clientId, familyMember);
  return putFamilyMember(advisorId, clientId, familyMemberId, familyMember);
};

export const saveOtherMember = (
  advisorId,
  clientId,
  otherMemberId,
  otherMember
) => {
  console.log("Advisor API - saveOtherMember");

  if (otherMemberId == null)
    return postOtherMember(advisorId, clientId, otherMember);
  return putOtherMember(advisorId, clientId, otherMemberId, otherMember);
};

export const deleteFamilyMember = (advisorId, clientId, familyMemberId) => {
  console.log("Advisor API - deleteFamilyMember");

  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/client/${clientId}/family-member/${familyMemberId}`
    );
    axios.delete(targetUrl).then(() => resolve({}));
  });
};

export const deleteOtherMember = (advisorId, clientId, otherMemberId) => {
  console.log("Advisor API - deleteOtherMember");

  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/client/${clientId}/client-contacts/${otherMemberId}`
    );
    axios.delete(targetUrl).then(() => resolve({}));
  });
};

export const deleteCoClient = (advisorId, clientId, coClientId) => {
  console.log("Advisor API - deleteCoClient");

  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/client/${clientId}/co-client/${coClientId}`
    );
    axios.delete(targetUrl).then(() => resolve({}));
  });
};

export const getOtherList = (advisorId, clientId) => {
  console.log("Advisor API - getOtherList");

  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/client/${clientId}/client-contacts`
    );

    axios.get(targetUrl).then((response) => {
      const payload = response.data.payload;
      let clientData = payload.map((member) => {
        let newMember = mapBEClientToFE(member, member.contactId);
        newMember.relationShip = {
          id: member.relationShip,
          name: member.relationShip,
        };
        newMember.relationshipOther = member.relationshipOther
          ? member.relationshipOther
          : "";
        return newMember;
      });

      resolve(clientData);
    });
  });
};
